/* @flow */

import * as React from 'react';

/**
 * A sandbox wrapper component used for React component development in isolation.
 *
 * DON'T COMMIT CHANGES TO THIS FILE!
 * Run `git update-index --assume-unchanged js/src/common/components/Sandbox.js`
 * to make your local copy ignored by Git.
 */
export default class Sandbox extends React.Component<{}> {
  render() {
    return <div />;
  }
}
